const messages = {
    ArchiveStatement: {
        message: "You're about to archive this statement, and all of the information provided.",
        translation: "@TODO"
    },
    Invalid: {
        message: "Validation error",
        translation: {
            en:{
                title:"Warning",
                message:"Validation error"
            }
        }
    },
    UserNotFoundException: [
        {
            message: "Username/client id combination not found.",
            translation: {
                en:{
                    title:"We couldn’t find your service",
                    message: "Please ensure you are entering the correct SE number"
                }
            }
        },
        {
            message: "User does not exist.",
            translation: {
                en:{
                    title:"We couldn’t find your service",
                    message: "Please ensure you are entering the correct SE number"
                }
            }
        }
    ],
    unknown: {
        message: "Passwords do not match",
        translation: {
            en:{
                message: "Please ensure the password and password confirmation are the same",
                title: "Passwords do not match"
            }
        }
    },
    CodeMismatchException: {
        message: "Invalid verification code provided, please try again.",
        translation: {
            en:{
                message: "Please try again",
                title: "Incorrect verification code"
            }
        }
    },
    LimitExceededException: {
        message: "Attempt limit exceeded, please try after some time.",
        translation: {
            en:{
                message: "Please try again in 30 minutes",
                title: "Too many failed login attempts"
            }
        }
    },
    NotAuthorizedException:[
		{
			message: "Incorrect username or password.",
			translation: {
				en:{
					message: "Please try again",
					title: "The SE number or password is incorrect" 
				}
			}      
		},
		{
			message: "Password attempts exceeded",
			translation: {
				en:{
					message: "Please try again in 5 minutes",
					title: "Too many failed login attempts" 
				}
			}      
		}
	],
    InvalidPasswordException: [
        {
            message: "Password did not conform with policy: Password must have uppercase characters",
            translation: {
                en:{
                    message: "Password must contain at least 1 uppercase letter",
                    title: "Password did not meet the following criteria"
                }
            }
        },
        {
            message: "Password did not conform with policy: Password must have numeric characters",
            translation: {
                en:{
                    message: "Password must contain at least 1 number",
                    title: "Password did not meet the following criteria"
                }
            }
        },      
        {
            message: "Password did not conform with policy: Password must have lowercase characters",
            translation: {
                en:{
                    message: "Password must contain at least 1 lowercase letter",
                    title: "Password did not meet the following criteria"
                }
            }
        },
        {
            message: "Password did not conform with policy: Password not long enough",
            translation: {
                en:{
                    message: "Password must have a minimum of 8 characters",
                    title: "Password did not meet the following criteria"
                }
            }
        },
        {
            message: "Password did not conform with policy: Password must have symbol characters",
            translation: {
                en:{
                    message: "Password must contain at least 1 symbol",
                    title: "Password did not meet the following criteria"
                }
            }
        }
    ],
    InvalidBirthDate: {
        message: "Can't have future dates for birthdays",
        translation: {
            en:{
                message:"Can't have future dates for the date of birth"
            }
        }
    },   
    UnArchiveStatement: {
        message: "You're about to unarchive this statement, and all of the information provided.",
        translation: {
            en:"You're about to unarchive this statement, and all of the information provided."
        }
      },
      DeleteStatement: {
        message: "You're about to permanently delete this statement, and all of the information provided.",
        translation: {
            en:{
                message:"You're about to permanently delete this statement, and all of the information provided.",
                title:"Delete statement?"
            }
        }
      },
      AlreadyCurrent: {
        message: "Statement is already current",
        translation: {
            en:{
                message: "Statement is already live"
            }
        }
      },
      NotInProgress: {
        message: "Only statements with status 'In Progress' can be deleted was: sent",
        translation: {
            en:{
                message:"Only statements 'In progress' can be deleted. Complete or sent statements can be archived."
            }
        }
      },
      AlreadyDeleted: {
        message: "Statement is already deleted",
        translation: {
            en:{
                message: "Statement is already deleted"
            }
        }
      }
};

export default messages;
